export const getAppConfig = async () => {
  const configResponse = await fetch("config.json");
  const response = await configResponse.json();
  return response;
};
